import React, { useCallback, useState } from 'react';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles.css';
import PopConfirm from '../../../../../../Layout/PopConfirm';

const CollectionProductHeader = props => {
  const { selectedProduct, selectedCollection, onDeleteToCollection, setSelectedProduct } = props;
  const isAttachment = selectedProduct?.type === 'attachment';
  const [showPopConfirm, setShowPopConfirm] = useState(false);

  const handleDownload = useCallback(async () => {
    if (!selectedProduct?.url) return;
    try {
      const response = await fetch(selectedProduct.url);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = selectedProduct.fileName || selectedProduct.description || 'download';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // Fallback to opening in new tab if fetch fails (e.g., CORS issues)
      window.open(selectedProduct.url, '_blank');
    }
  }, [selectedProduct]);

  const onDelete = useCallback(async () => {
    await onDeleteToCollection(selectedProduct.id, selectedProduct.type);
    setShowPopConfirm(false);
    setSelectedProduct(null);
  }, [selectedProduct, onDeleteToCollection]);

  return (
    <div className="clients-v2-product-details--header">
      <span className="clients-v2-product-details--header-title">Product Details</span>

      {!selectedProduct?.viewDetails && (
        <div className="clients-v2-product-details--header-options">
          {isAttachment && selectedProduct?.url && (
            <Button
              type="link"
              icon={<FontAwesomeIcon icon="far fa-download" />}
              onClick={handleDownload}
            >
              Download
            </Button>
          )}
          <Button
            type="link"
            icon={<FontAwesomeIcon icon="far fa-trash-alt" />}
            onClick={() => setShowPopConfirm(true)}
            danger
          >
            Remove from Collection
          </Button>
        </div>
      )}
      {showPopConfirm && (
        <PopConfirm
          confirm={`Are you sure you want to delete "${selectedProduct.name ?? selectedProduct.description}" from "${selectedCollection.name}" collection?`}
          onCancel={() => setShowPopConfirm(false)}
          onConfirm={onDelete}
        />
      )}
    </div>
  );
};

export default CollectionProductHeader;
